import { ApprovalStatus, PositionImage } from "../../../../interfaces";
import UpdatedAcceptedLogs from "./UpdatedAcceptedLogs";
import UpdatedDeclinedLogs from "./UpdatedDeclinedLogs";

/**
 * This component is used to return card of accepted or decline position image
 * @param param0 position image details , created At and updated by details
 */
const UpdatedPositionImageLog = ({
  positionImage,
  createdAt,
  updatedBy,
}: {
  positionImage: PositionImage;
  createdAt: string;
  updatedBy: string;
}) => {
  const updatedLogs = (
    positionImage: PositionImage,
    createdAt: string,
    updatedBy: string,
  ) => {
    switch (positionImage.approvalStatus) {
      case ApprovalStatus.Yes:
        return (
          <UpdatedAcceptedLogs
            positionImage={positionImage}
            createdAt={createdAt}
            updatedBy={updatedBy}
          />
        );
      case ApprovalStatus.No:
        return (
          <UpdatedDeclinedLogs
            positionImage={positionImage}
            createdAt={createdAt}
            updatedBy={updatedBy}
          />
        );
      default:
        return <></>;
    }
  };
  return (
    <div className="my-10">
      {updatedLogs(positionImage, createdAt, updatedBy)}
    </div>
  );
};

export default UpdatedPositionImageLog;
